module.exports = __webpack_public_path__ + "img/L3.1e3c7360.png";